/**
 * The question shapes the backend can describe, as a neutral lowercase union
 * that never names a generated GraphQL enum. Each domain (manager, survey)
 * owns the adapter that maps its own `QuestionType` enum onto these names.
 */
export const QUESTION_SHAPES = {
  Message: 'message',
  MobileApp: 'mobileApp',
  MultipleChoice: 'multipleChoice',
  OpenEnded: 'openEnded',
  Ranking: 'ranking',
  Rating: 'rating',
  Task: 'task',
  Url: 'url',
} as const;

export type QuestionShape =
  (typeof QUESTION_SHAPES)[keyof typeof QUESTION_SHAPES];

/**
 * Schema-free equivalents of GraphQL's four `OptionRenderType` values. Only
 * `media` changes a question's kind, but rating surfaces still need `emoji`
 * and `star` to preserve the author-selected presentation.
 */
export const OPTION_RENDER_TYPES = {
  Text: 'text',
  Media: 'media',
  Emoji: 'emoji',
  Star: 'star',
} as const;

export type OptionRenderType =
  (typeof OPTION_RENDER_TYPES)[keyof typeof OPTION_RENDER_TYPES];
